import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import store from '@/store'

export const useTransformsStore = defineStore('transforms', {
  state: () => ({
    transforms: [],
    fetchInitiated: false,
  }),

  getters: {
    forId: ({ transforms }) => (id) => {
      return transforms.find(transform => transform.id === id)
    }
  },

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/transforms')
        .then(response => {
          this.transforms = response.data.transforms
        })
        .catch((err) => {
          store.dispatch('messages/smartAdd', err)
        })
    },

    async destroy(transformId) {
      return httpClient.delete(
        `/api/internal/transforms/${transformId}`
      ).then(response => {
        this.transforms = this.transforms.filter(tform => tform.id !== transformId)
        return response
      }).catch((err) => {
        store.dispatch('messages/smartAdd', err)
      })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    }
  }
})
